export default __webpack_public_path__ + "static/media/641.097dbfca.png";